// Extracts a readable message from an apiFetcher rejection. The backend answers either
// { error: { code, message } } (ErrorHandler) or { message, detail, missingFields } (inline).
export const apiErrorMessage = (e, fallback = 'Erro inesperado') => {
    const message = e?.error?.message || e?.message || fallback;
    const detail = e?.detail ? ` (${e.detail})` : '';
    const fields = e?.missingFields ? ` (campos faltando: ${e.missingFields.join(', ')})` : '';
    return `${message}${detail}${fields}`;
};
